import axios from 'axios';
import { trackingPublishEvent } from "../data/Contentapi";
import { getConfig } from "../loadconfig";
import Constants from './Constants';



export const commonPublishEvent = async (eventName, requestData, jwtToken, sessionId) => {
    const config = getConfig();
    const url = config.PUBLISH_EVENT_URL;
    
    const secChUa = navigator.userAgentData
        ? await navigator.userAgentData.getHighEntropyValues(['platform', 'mobile', 'ua'])
        : null;

    const formattedSecChUa = secChUa ?
        secChUa.brands.map(brand => `${brand.brand};v=${brand.version}`).join(', ')
        : 'Not available';

    let ipAddressClient = '';
    try {
        const response = await axios.get(Constants.IP_ADDRESS_URL);
        ipAddressClient = response.data.ip;
    } catch (error) {
        console.error('Error fetching IP address:', error);
        ipAddressClient = 'Unable to fetch IP';
    }

    let eventData = {

        "requestDetails": requestData,
        "session": {
            "sessionID": sessionId,
            "sourceAddress": ipAddressClient,
            "applicationID": "portal",
            "sequenceId": "1",
            "browser": formattedSecChUa
        },
        "eventEndTime": getFormattedEventStartTime(),
        "eventName": eventName,
        "responseDetails": {
        },
        "eventStartTime": getFormattedEventStartTime(),
        "source": "Web",
        "ipAddressClient": ipAddressClient,
        "flow": "providerSearch"
    };

    trackingPublishEvent(url, eventData, jwtToken)
}

function getFormattedEventStartTime() {
    return {"$date": new Date().toISOString()};
}